import { useEffect, useState } from 'react';
import { colors, spacing } from '../theme';
import Card from '../components/Card';
import Table from '../components/Table';
import EmptyState from '../components/EmptyState';
import SkeletonLoader from '../components/SkeletonLoader';
import { supabase } from '../lib/supabase';

function AuditLog() {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      if (!supabase) return;
      setLoading(true);
      const { data, error } = await supabase
        .from('audit_events')
        .select('*')
        .order('created_at', { ascending: false })
        .limit(100);
      if (!cancelled) {
        setEvents(error ? [] : data || []);
        setLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  const columns = [
    {
      key: 'created_at',
      label: 'When',
      render: (row) => new Date(row.created_at).toLocaleString(),
    },
    { key: 'action', label: 'Action' },
    { key: 'target_type', label: 'Target type' },
    { key: 'target_id', label: 'Target ID' },
    {
      key: 'metadata',
      label: 'Details',
      render: (row) => (
        <span style={{ fontSize: '0.75rem', color: colors.midGray }}>
          {JSON.stringify(row.metadata || {}).slice(0, 80)}
          {(JSON.stringify(row.metadata || {}).length > 80 ? '…' : '')}
        </span>
      ),
    },
  ];

  return (
    <Card title="Audit log">
      {loading ? (
        <SkeletonLoader variant="table" count={5} />
      ) : events.length === 0 ? (
        <EmptyState title="No audit events yet" description="Matching actions will be logged here." />
      ) : (
        <Table columns={columns} data={events} keyField="id" responsive />
      )}
    </Card>
  );
}

export default AuditLog;
